module.exports = __webpack_public_path__ + "img/R2.7a92e68d.jpeg";